export interface IWatrChaseExport {
    bankAccountType: string,
    bankRoutingNumber: string,
    bankAccountNumber: string,
    personalOrBusiness: string,
    primaryPayFromAccount: string,
    group: string,
    groupDescription: string
}